module.exports = __webpack_public_path__ + "static/media/CycleTime.8d8ad506.svg";